import styled from '@emotion/styled';
import BackArrowSrc from '~Assets/icons/arrow_back.svg';
import CheckIconSrc from '~Assets/icons/check.svg';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  @media (min-width: 480px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (min-width: 768px) {
    grid-template-columns: repeat(6, 1fr);
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(8, 1fr);
  }
  @media (min-width: 1280px) {
    grid-template-columns: repeat(12, 1fr);
  }
  grid-gap: 1rem;
`;

export const BaseButton = styled.div<{
  touching?: boolean;
  color?: string;
  border?: string;
  fontSize?: string;
}>`
  padding: 16px 4px;
  width: 56px;
  text-align: center;
  border-radius: 4px;
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '12px')};
  font-weight: 600;
  letter-spacing: 0.2px;
  line-height: 16px;
  border: ${({ border }) => (border ? border : 'none')};
  color: ${({ color }) => (color ? color : '#fff')};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2), 0 0 12px rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  cursor: pointer;

  transform: ${({ touching }) => (touching ? 'scale(0.96)' : '1')};
  transition: transform 0.1s ease-out, opacity 0.1s ease-in-out;
`;

export const GreenButton = styled(BaseButton)`
  background: linear-gradient(-180deg, rgb(32, 153, 70) 0%, rgb(23, 132, 69) 100%);
`;

export const BlackButton = styled(BaseButton)`
  background: var(--colorBlueGray1300);
`;

export const WhiteButton = styled(BaseButton)`
  background: var(--colorBlueGray100);
  color: var(--colorBlueGray1200);
`;

export const RemoveButton = styled(BaseButton)`
  background: var(--colorUIRed);
`;

export const BackIcon = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  mask-image: url(${BackArrowSrc});
  mask-size: contain;
  mask-repeat: no-repeat;
  background: var(--colorBlueGray100);
  margin-right: 16px;
`;

export const SidebarTitle = styled.div`
  font-size: 14px;
  font-weight: 300;
  color: #fff;
  text-align: center;
  margin-top: 10px;
`;

export const SidebarValue = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  text-align: center;
`;

export const SettingsWrapper = styled.div`
  margin: 0;
  padding: 16px;
  min-height: 100%;
  box-sizing: border-box;
  background: var(--colorBlueGray1200);
`;

export const TextButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
`;

export const Check = styled.div<{ selected: boolean }>`
  width: 24px;
  height: 24px;
  mask-image: url(${CheckIconSrc});
  mask-size: contain;
  mask-repeat: no-repeat;
  background: ${(props) => (props.selected ? 'var(--colorUIGreen)' : 'var(--colorBlueGray300)')};
  margin-left: 16px;
  flex: 0 0 24px;
  transition: background 0.1s ease-in-out;
`;

export const ModalContent = styled.div`
  padding: 24px;
  background: var(--colorBlueGray1200);
  border-radius: 8px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);
  width: calc(100% - 64px);
  max-width: 400px;

  max-height: calc(100% - 128px);
  overflow-y: auto;
`;

// Search input iOS styling
export const Input = styled.input`
  border: none;
  border-radius: 8px;
  background-color: var(--colorBlueGray50);
  padding: 8px 16px;
  width: 100%;
  max-width: 400px;
  margin-top: 16px;
  font-size: 16px;
  font-weight: 500;
  color: var(--colorBlueGray1300);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  outline: none;

  box-sizing: border-box;

  &::placeholder {
    color: var(--colorBlueGray1300);
    opacity: 0.5;
  }

  &:focus {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  }
`;

export const COLORS = {
  // Bluegray
  blueGray50: 'var(--colorBlueGray50)',
  blueGray100: 'var(--colorBlueGray100)',
  blueGray200: 'var(--colorBlueGray200)',
  blueGray300: 'var(--colorBlueGray300)',
  blueGray400: 'var(--colorBlueGray400)',
  blueGray500: 'var(--colorBlueGray500)',
  blueGray600: 'var(--colorBlueGray600)',
  blueGray700: 'var(--colorBlueGray700)',
  blueGray800: 'var(--colorBlueGray800)',
  blueGray900: 'var(--colorBlueGray900)',
  blueGray1000: 'var(--colorBlueGray1000)',
  blueGray1100: 'var(--colorBlueGray1100)',
  blueGray1200: 'var(--colorBlueGray1200)',
  blueGray1300: 'var(--colorBlueGray1300)',

  // UI
  uiSand: 'var(--colorUISand)',
  uiYellow: 'var(--colorUIYellow)',
  uiOrange: 'var(--colorUIOrange)',
  uiRed: 'var(--colorUIRed)',
  uiGreen: 'var(--colorUIGreen)',
  uiBlue: 'var(--colorUIBlue)',
  uiPurple: 'var(--colorUIPurple)',

  // Status
  statusGreen: 'var(--colorStatusGreen)',
  statusRed: 'var(--colorStatusRed)',
  statusOrange: 'var(--colorStatusOrange)',
  statusBlue: 'var(--colorStatusBlue)',
  statusGray: 'var(--colorStatusGray)',

  // Base
  transparent: 'transparent',
};
